export default __webpack_public_path__ + "static/media/left-nav-arrow.eb81ffea.svg";